import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../api/client";

/**
 * The current user's in-app notifications + unread count.
 * Polls every 60s so the bell stays roughly current without a websocket.
 */
function useNotifications(enabled = true) {
  return useQuery({
    queryKey: ["notifications"],
    queryFn: () => apiClient.get("/api/v1/notifications/").then((r) => r.data),
    enabled,
    refetchInterval: 60000,
    refetchOnWindowFocus: true,
  });
}

function useMarkNotificationRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) =>
      apiClient.post(`/api/v1/notifications/${id}/read/`).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["notifications"] }),
  });
}

function useMarkAllNotificationsRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () =>
      apiClient.post("/api/v1/notifications/read-all/").then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["notifications"] }),
  });
}

export { useNotifications, useMarkNotificationRead, useMarkAllNotificationsRead };
